<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M16,0A13.09,13.09,0,0,1,29,13.17c0,5.56-3.86,11.63-11.48,18.26a2.31,2.31,0,0,1-3,0L14,31C6.69,24.53,3,18.61,3,13.17A13.09,13.09,0,0,1,16,0Zm0,8.1a5,5,0,0,0-3.54,1.49,5.12,5.12,0,0,0,0,7.16,5,5,0,0,0,7.08,0,5.12,5.12,0,0,0,0-7.16A5,5,0,0,0,16,8.1Z" />
</svg>
